import DefaultProps from "./default-props";
import withResponsiveHOC from "components/enhancements/responsive-hoc/responsive-hoc-component";
import DesktopCarouselTagsComponent from "./desktop-carousel-tags/desktop-carousel-tags-component";
import MobileCarouselTagsComponent from "./mobile-carousel-tags/mobile-carousel-tags-component";
const CarouselSelectableProductCardsGridComponent = withResponsiveHOC(DesktopCarouselTagsComponent, MobileCarouselTagsComponent);
CarouselSelectableProductCardsGridComponent.defaultProps = DefaultProps;
export default CarouselSelectableProductCardsGridComponent;
